import { render, staticRenderFns } from "./nonPremiumJobScreen.vue?vue&type=template&id=b6461326&scoped=true&"
import script from "./nonPremiumJobScreen.vue?vue&type=script&lang=js&"
export * from "./nonPremiumJobScreen.vue?vue&type=script&lang=js&"
import style0 from "./nonPremiumJobScreen.vue?vue&type=style&index=0&id=b6461326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6461326",
  null
  
)

export default component.exports